import { AdyenPaymentMethodModel as t } from "../adyenPaymentMethod.model.js";
class r extends t {
  constructor(o) {
    super(o), this.configuration = o.configuration;
  }
}
export {
  r as AdyenApplePaymentMethod
};
//# sourceMappingURL=adyenApplePayPaymentMethod.model.js.map
